import i from "./_index.js"
export default i;